/** @format */

import React, { useState, useEffect } from "react";
import Table from "../../../Components/Table/Index";
import { useGetAll } from "../../../Hooks/useGetAll";
import PrimaryButton from "../../../Components/Inputs/PrimaryButton";
import AddSponsors from "../../../Components/AdminPanelDialogs/AddSponsors/Index";
import { Link } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { colors } from "../../../Constants/theme";

function Index() {
  const [tabValue, setTabValue] = useState(0);

  const [currentLimit, setCurrentLimit] = useState(10);
  const [currentRows, setCurrentRows] = useState([]);

  const [oldLimit, setOldLimit] = useState(10);
  const [oldRows, setOldRows] = useState([]);

  // Fetch Current Sponsors Total Count to bypass pagination
  const { data: currentLimitData, refetch: refetchCurrentLimit } = useGetAll({
    key: `/records/sponsors/current/nt/`,
    select: (data) => data,
    onSuccess: (data) => {
      if (data?.data?.total_count) {
        setCurrentLimit(data.data.total_count);
      }
    },
  });

  // Fetch Current Sponsors
  const { data: currentSponsorsData, refetch: refetchCurrent } = useGetAll({
    key: `/records/sponsors/current/nt/`,
    params: { limit: currentLimit },
    select: (data) => data?.data?.rows,
    onSuccess: (data) => {
      if (data) {
        setCurrentRows(mapApiDataToTableRows(data));
      }
    },
  });

  // Fetch Old Sponsors Total Count to bypass pagination
  const { data: oldLimitData, refetch: refetchOldLimit } = useGetAll({
    key: `/records/sponsors/old/nt/`,
    select: (data) => data,
    onSuccess: (data) => {
      if (data?.data?.total_count) {
        setOldLimit(data.data.total_count);
      }
    },
  });

  // Fetch Old Sponsors
  const { data: oldSponsorsData, refetch: refetchOld } = useGetAll({
    key: `/records/sponsors/old/nt/`,
    params: { limit: oldLimit },
    select: (data) => data?.data?.rows,
    onSuccess: (data) => {
      if (data) {
        setOldRows(mapApiDataToTableRows(data));
      }
    },
  });

  const mapApiDataToTableRows = (apiData) => {
    return apiData?.map((item) => ({
      id: item.id,
      s_name: item.s_name,
      end_date: item?.end_date ? new Date(item.end_date).toLocaleDateString() : "N/A",
      since: item.since ? new Date(item.since).toLocaleDateString() : "N/A",
      donation_type: item.donation_type,
      address: item.address,
      no_of_students: item.no_of_students,
    }));
  };

  const columns = [
    { field: "s_name", headerName: "Sponsor Name", width: 130 },
    {
      field: "since",
      headerName: "Start Date",
    },
    {
      field: "end_date",
      headerName: "End Date",
    },
    {
      field: "donation_type",
      headerName: "Donation Frequency",
    },
    {
      field: "address",
      headerName: "Address",
      type: "string",
      width: 120,
    },
    {
      field: "no_of_students",
      headerName: "Number of students",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <Link to='Edit' state={{ id: params?.id }}>
          <PrimaryButton
            sx={{
              borderRadius: 1,
              height: "30px",
              background: colors.primary.light,
              "&:hover": {
                background: colors.primary.dark,
              },
            }}
          >
            Edit
          </PrimaryButton>
        </Link>
      ),
    },
  ];

  useEffect(() => {
    if (currentSponsorsData) {
      setCurrentRows(mapApiDataToTableRows(currentSponsorsData));
    }
  }, [currentSponsorsData]);

  useEffect(() => {
    if (oldSponsorsData) {
      setOldRows(mapApiDataToTableRows(oldSponsorsData));
    }
  }, [oldSponsorsData]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleRefetch = () => {
    refetchCurrentLimit();
    refetchCurrent();
    refetchOldLimit();
    refetchOld();
  };

  return (
    <div className=''>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          sx={{
            "& .MuiTab-root": {
              fontFamily: "roboto",
              fontSize: "1rem",
              fontWeight: "500",
              textTransform: "capitalize",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: colors.primary.light,
            },
            "& .Mui-selected": {
              color: `${colors.primary.light} !important`,
            },
          }}
        >
          <Tab label="Current Sponsors" />
          <Tab label="Old Sponsors" />
        </Tabs>
      </Box>

      {tabValue === 0 && (
        <Table
          columns={columns}
          title='Current Sponsors'
          rows={currentRows}
          DeleteUrl={`/records/delete-multiple-sponsors/`}
          refetchUrl={`/records/sponsors/current/nt/`}
          addButton={<AddSponsors onSuccess={handleRefetch} />}
        />
      )}

      {tabValue === 1 && (
        <Table
          columns={columns}
          title='Old Sponsors'
          rows={oldRows}
          DeleteUrl={`/records/delete-multiple-sponsors/`}
          refetchUrl={`/records/sponsors/old/nt/`}
          addButton={<AddSponsors onSuccess={handleRefetch} />}
        />
      )}
    </div>
  );
}

export default Index;